import { useQuery } from "@tanstack/react-query";
import { fetcher } from "../../../utils/Axios";
import { GET_CASE_DELAY_BREAKDOWN_QUERY_KEY } from "../types/CommonTypes";

async function getCaseDelayBreakdown(
  tenantId: string,
  hospitalId: string,
  queryString: string
) {
  const { data } = await fetcher({
    url: `/analytics/delay-breakdown?${queryString}`,
    method: "GET",
    headers: {
      "x-tenant-id": tenantId,
      "x-hospital-id": hospitalId,
    },
  });
  return data;
}

function useGetCaseDelayBreakdownQuery(
  tenantId: string,
  hospitalId: string,
  queryString: string = ""
) {
  return useQuery({
    queryKey: [
      GET_CASE_DELAY_BREAKDOWN_QUERY_KEY,
      queryString,
      tenantId,
      hospitalId,
    ],
    queryFn: () => getCaseDelayBreakdown(tenantId, hospitalId, queryString),
    refetchInterval: 60000,
  });
}

export default useGetCaseDelayBreakdownQuery;
